import Layout from "../components/layout/Layout";
import StatisticsMessage from "../components/StatisticsMessage";

const StatisticsMessagePage = () => {

  return (
    <Layout>
        <StatisticsMessage />
    </Layout>
  );
};
export default StatisticsMessagePage;
